<div class="qb-create-new-form-div">
  <span class="qb-create-new-form cursor-pointer" (click)="createForm()"
    >{{'ACQUIRE_PAGE.CREATE_NEW_FORM' | i18nTranslate}}</span
  >
</div>
